import {
    Component, Mixins, Emit,
} from 'vue-property-decorator';
import Classes from '@groot-components/shared/mixins/classes';
import Hybrid from '@groot-components/shared/mixins/hybrid';
import config from '@groot-components/shared/config';
import { YSelect } from '@groot-components/select';
import { options as localeOptions } from '@groot-nodes/locales';
import Props from './props';

/**
 * @name SelectFlag
 */
@Component({
    components: {
        YSelect,
    },
})
class YSelectFlag extends Mixins(Props, Classes, Hybrid) {
    /**
     * Props list that active by developer
     */
    activeCommonProps: Array<string> = ['color', 'size'];

    /**
     * The css parent class of the component
     */
    parentClass: string = this.componentClass(this.baseClass, config.prefix.selectFlag);

    /**
     * Create Common Props for the selectFlag.
     * 
     * @returns {object} - List of props
     */
    get commonProps(): Record<string, any> {
        const commonProps: Record<string, any> = {
            baseClass: this.baseClass,
        };
        this.activeCommonProps.forEach((item) => {
            if (this.elements && this.elements[item]) {
                commonProps[item] = this.elements[item];
            } else {
                commonProps[item] = this[item];
            }
        });
        return commonProps;
    }

    /**
     * Create classes array for the selectFlag.
     * 
     * @returns {Array} - Array of classes
     */
    get classes(): Array<string> {
        const cls: Array<string> = [];
        cls.push(...this.commonClasses('SelectFlag', this.commonProps, this.baseClass || config.prefix.selectFlag));
        return cls;
    }

    /**
     * Return available options locales
     * 
     * @returns {Array}
     */
    get availableLocales(): Array<any> {
        let langs = [];

        if (this.$i18n.availableLocales && this.$i18n.availableLocales.length > 1) {
            // eslint-disable-next-line global-require
            langs = this.$i18n.availableLocales.map((loc: any) => ({
                // eslint-disable-next-line global-require, import/no-dynamic-require
                img  : require(`./assets/images/flags/${this.getValue('flagType')}/${loc}.svg`),
                label: localeOptions.find((item: { code: any; }) => item.code === loc).title,
                value: loc,
            }));
        }

        return this.getValue('languages') || langs;
    }

    /**
     * Return init select values
     * 
     * @returns {string}
     */
    get initLocal(): string {
        return this.availableLocales.find((locale) => locale.value === this.$route.params?.locale)?.value || this.availableLocales[0].value;
    }

    /**
     * Emit change select flag.
     *
     * @param {object} e - selected object
     * @returns {*}
     */
    @Emit('changeFlag')
    handleSelectChange(e: {[k: string]: any}): any {
        return e;
    }
}

export default YSelectFlag;
